/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import PhysicalObjectType from './PhysicalObjectType';
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}physicalObjectType"&gt; &lt;sequence&gt; &lt;element name="numberOfRows" type="{http://www.w3.org/2001/XMLSchema}long" minOccurs="0"/&gt; &lt;element name="procParameter" type="{}procParameterType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}column" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class StoredProcedure extends PhysicalObjectType{

	numberOfRows = null;

	procParameter = null;

	column = null;



	/**
	 * Gets the value of the numberOfRows property.
	 * @return {Number} possible object is {@link Long}
	 */
	getNumberOfRows() {
		return this.numberOfRows;
	}

	/**
	 * Sets the value of the numberOfRows property.
	 * @param {Number} value allowed object is {@link Long}
	 */
	setNumberOfRows(value) {
		var oldValue = this.numberOfRows;
		this.numberOfRows = value;
		this._setAndNotify(61, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the procParameter property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the procParameter property. <p> For example, to add a new item, do as follows: <pre> getProcParameter().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ProcParameterType}
	 */
	getProcParameter() {
		if (!this.procParameter) {
			this.procParameter = [];
		}
		return this.procParameter;
	}

	/**
	 * Gets the value of the column property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the column property. <p> For example, to add a new item, do as follows: <pre> getColumn().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Column}
	 */
	getColumn() {
		if (!this.column) {
			this.column = [];
		}
		return this.column;
	}

	/**
	 * Gets the value of the <code>procParameter</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ProcParameterType</code> elements, or <code>null</code> if not set
	 */
	basicGetProcParameter() {
		return this.procParameter;
	}

	/**
	 * Gets the value of the <code>column</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Column</code> elements, or <code>null</code> if not set
	 */
	basicGetColumn() {
		return this.column;
	}

	/**
	 * Creates a new instance of <code>StoredProcedure</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> StoredProcedure</code> object from.
	 * @return {StoredProcedure} an object of type <code>StoredProcedure</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createStoredProcedure();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addProcParameterAt(position, item) {
		this._addAtAndNotify(this.getProcParameter(), position, item, 162, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addProcParameter(item) {
		this.addProcParameterAt(this.getProcParameter().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeProcParameterAt(position) {
		this._removeAtAndNotify(this.getProcParameter(), position, 162, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeProcParameter(item) {
		var i = this.getProcParameter().indexOf(item);
		if (i >= 0) {
			this.removeProcParameterAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addColumnAt(position, item) {
		this._addAtAndNotify(this.getColumn(), position, item, 196, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addColumn(item) {
		this.addColumnAt(this.getColumn().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeColumnAt(position) {
		this._removeAtAndNotify(this.getColumn(), position, 196, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeColumn(item) {
		var i = this.getColumn().indexOf(item);
		if (i >= 0) {
			this.removeColumnAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "StoredProcedure";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 61, "numberOfRows", null));
		var clazz;
		if (factory) {
			clazz = factory.createProcParameterType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 162, "procParameter", clazz));
		if (factory) {
			clazz = factory.createColumn().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 196, "column", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 61:
			this.setNumberOfRows((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 196:
			this.column = (value);
			break;
		case 162:
			this.procParameter = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 196:
			return this.getColumn();
		case 61:
			return this.getNumberOfRows();
		case 162:
			return this.getProcParameter();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 196:
			return this.basicGetColumn();
		case 61:
			return this.getNumberOfRows();
		case 162:
			return this.basicGetProcParameter();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 196:
			this.addColumnAt(position, (value));
			break;
		case 162:
			this.addProcParameterAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 196:
			this.addColumn((value));
			break;
		case 162:
			this.addProcParameter((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 196:
			this.removeColumnAt(position);
			break;
		case 162:
			this.removeProcParameterAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 196:
			this.removeColumn((item));
			break;
		case 162:
			this.removeProcParameter((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/StoredProcedure.js